import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA9wjn0-ygWobsn3aGP8oY8FhOtBkfs2HU",
  authDomain: "taskamoon-notif.firebaseapp.com",
  projectId: "taskamoon-notif",
  storageBucket: "taskamoon-notif.firebasestorage.app",
  messagingSenderId: "372832240745",
  appId: "1:372832240745:web:1b2f3eb9e8135047a5cef8",
};

export const app = initializeApp(firebaseConfig);

let messaging = null;
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (err) {
    console.warn("FCM is not supported in this browser:", err);
  }
}

export { messaging };

export const isNotificationSupported = () =>
  !!messaging && typeof Notification !== "undefined";

export const getNotificationPermission = () =>
  typeof Notification === "undefined" ? "unsupported" : Notification.permission;

const log = (step, detail) =>
  process.env.NODE_ENV !== "production" &&
  console.log(`[FCM] ${step}`, detail ?? "");

export const settleWithin = (promise, ms) =>
  Promise.race([
    Promise.resolve(promise),
    new Promise((resolve) => setTimeout(resolve, ms, null)),
  ]);

const fail = (step, err) => {
  console.error(`[FCM] ✗ ${step}`, {
    name: err?.name,
    code: err?.code,
    message: err?.message,
    error: err,
  });
  return null;
};

const registerFcmServiceWorker = () =>
  navigator.serviceWorker.register("/firebase-messaging-sw.js", {
    scope: "/firebase-cloud-messaging-push-scope",
  });

const waitForActiveWorker = (registration) => {
  if (registration.active) return Promise.resolve();

  const worker = registration.installing || registration.waiting;
  if (!worker) return Promise.resolve();

  return new Promise((resolve) => {
    const onChange = () => {
      log("service worker state", worker.state);
      if (worker.state === "activated" || worker.state === "redundant") {
        worker.removeEventListener("statechange", onChange);
        resolve();
      }
    };
    worker.addEventListener("statechange", onChange);
  });
};

export const requestFcmToken = async () => {
  const vapidKey = process.env.REACT_APP_VAPID_KEY;

  log("start", {
    messaging: !!messaging,
    notificationApi: typeof Notification !== "undefined",
    serviceWorkerApi: "serviceWorker" in navigator,
    secureContext: window.isSecureContext,
    online: navigator.onLine,
    origin: window.location.origin,
    vapidKeyLength: vapidKey ? vapidKey.length : 0,
  });

  if (!isNotificationSupported()) {
    console.error("[FCM] ✗ unsupported: messaging or Notification missing");
    return null;
  }

  if (!vapidKey) {
    console.error("[FCM] ✗ REACT_APP_VAPID_KEY is empty");
    return null;
  }

  let permission = Notification.permission;
  log("permission (before)", permission);

  if (permission === "default") {
    try {
      permission = await Notification.requestPermission();
    } catch (err) {
      return fail("requestPermission threw", err);
    }
  }

  log("permission (after)", permission);
  if (permission !== "granted") {
    console.error("[FCM] ✗ permission not granted:", permission);
    return null;
  }

  let registration;
  try {
    registration = await registerFcmServiceWorker();
    log("service worker registered", {
      scope: registration.scope,
      active: !!registration.active,
      installing: !!registration.installing,
      waiting: !!registration.waiting,
    });
  } catch (err) {
    return fail("service worker registration failed", err);
  }

  try {
    await waitForActiveWorker(registration);
    log("service worker ready", {
      active: !!registration.active,
      scriptURL: registration.active?.scriptURL,
    });
  } catch (err) {
    return fail("service worker never activated", err);
  }

  try {
    log("calling getToken…");
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (!token) {
      console.error("[FCM] ✗ getToken resolved empty");
      return null;
    }

    log("✓ token", `${token.slice(0, 24)}… (len ${token.length})`);
    return token;
  } catch (err) {
    return fail("getToken failed", err);
  }
};
